import { render, staticRenderFns } from "./CampOrSchool.vue?vue&type=template&id=1dd35bd8"
import script from "./CampOrSchool.vue?vue&type=script&lang=js"
export * from "./CampOrSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports